import { TableBody, TableCell, TableHead, TableRow } from '@mui/material'

// others
import { NOT_APPLICABLE, References_Headers } from '../../constants'
import { ReferencesListingProps } from '../../interfaceTypes/props'

// components
import { StickyTable } from '../common/StickyTable'
import { TableSkeleton } from '../skeletons/TableSkeleton'
import { CustomTableCell } from '../common/CustomTableCell'
import { CustomPagination } from '../common/CustomPagination'
import Reference from '../menus/Reference'

const ReferencesListing = ({ references, loading, refetch }: ReferencesListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height="370px">
      <TableHead>
        <TableRow hover>
          {References_Headers.map((columnName, index) => (
            <TableCell
              key={index}
              component="th"
              align={columnName === 'Active' || columnName === 'Eligible for 1099 Report' ? 'center' : 'left'}
              width={index === References_Headers.length - 1 ? '100px' : 'auto'}
            >
              {columnName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {loading ? (
        <TableSkeleton noOfRows={7} noOfCols={References_Headers.length} />
      ) : (
        <TableBody>
          {references?.map(reference => {
            const { id, referral, referralSource, eligibleFor1099Report, active } = reference || {}
            const { sourceType } = referralSource || {}

            return (
              <TableRow key={id} hover>
                <CustomTableCell value={referral || NOT_APPLICABLE} maxWidth="376px" />
                <CustomTableCell value={sourceType || NOT_APPLICABLE} maxWidth="376px" />

                <CustomTableCell value={!!active} />
                <CustomTableCell value={!!eligibleFor1099Report} />
                <TableCell>
                  <Reference reference={reference} refetch={refetch} />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      )}
    </StickyTable>
  )
}

export default ReferencesListing
